import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'ui-components/components/checkbox';
import { FormattedMessage } from 'react-intl';
import style from './style.module.less';

export const AlertsGridHeader = ({ isSelected, onSelectAllChanged }) => {
  return (
    <div className={style['alerts-grid-header']}>
      <div className={style['alert-row-selector']}>
        <Checkbox checked={isSelected} onChange={onSelectAllChanged} />
      </div>
      <div>
        <FormattedMessage defaultMessage='Type' description='alertsGridHeader.type' id='Br1Tnb' />
      </div>
      <div>
        <FormattedMessage defaultMessage='Description' description='alertsGridHeader.description' id='cABxJv' />
      </div>
    </div>
  );
};

AlertsGridHeader.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onSelectAllChanged: PropTypes.func.isRequired,
};
